import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from '../../../../../air/modules/common/lib/air-api-constant';
import { StorageService } from '../../../../../air/modules/common/service/storage/storage.service';
import { FilterService } from '../../../../../air/modules/common/service/filter/filter.service';
import { BehaviorSubject, Observable, catchError, interval, map, repeatWhen, shareReplay, startWith, switchMap, throwError, timer } from 'rxjs';
import { CommonService } from '../common/common.service';
import { UserEndPoint } from '../../../../../air/modules/common/lib/air-api-constant';

interface AirUserDTO {
    id?: number;
    name: string;
    email: string;
    firstName: string;
    lastName: string;
    roleId: number;
    companies: number[];
    companyName: string;
}

@Injectable({
    providedIn: 'root',
})
export class UserControlService {


    private userFeaturesPromise = new BehaviorSubject<any>([
        { id: 1, name: 'Event Tracking' },
        { id: 2, name: 'Data Management' },
        { id: 3, name: 'User Management' },
    ]);
    public $userFeatures = this.userFeaturesPromise.asObservable();
    private userCompanyPromise = new BehaviorSubject<any>(null);
    public $userCompany = this.userCompanyPromise.asObservable();
    private existingUsertableHeaders: any[] = [
        { field: 'firstName', header: 'First Name' },
        { field: 'lastName', header: 'Last Name' },
        { field: 'companyName', header: 'Company Name' },
        { field: 'emailAddress', header: 'Email Address' },
        { field: 'assignedCompanies', header: 'Assigned Companies' },
        { field: 'actions', header: 'Actions' },
    ];
    private pendingUsertableHeaders: any[] = [
        { field: 'firstName', header: 'First Name' },
        { field: 'lastName', header: 'Last Name' },
        { field: 'companyName', header: 'Company Name' },
        { field: 'emailAddress', header: 'Email Address' },
        { field: 'actions', header: 'Actions' },
    ];
    public selectedUsers: any[] = [];
    companies: any[] = [];
    assignments: any[] = [];
    private userAttributeCache = new BehaviorSubject<any>(null);
    private userAttributeLoaded = false;
    private cachedAttribute$: Observable<any>;
    constructor(
        protected http: HttpClient,
        protected filterService: FilterService,
        protected storageService: StorageService,
        protected commonService: CommonService) {
        const features: any = this.storageService.getItem('userFeatures');
        if (features) {
            this.userFeaturesPromise.next(features);
        }
    }

    getTableHeaders(activeIndex: number) {
        if (activeIndex) return this.existingUsertableHeaders;
        else return this.pendingUsertableHeaders;
    }
    getFeature() {
        return this.http.get<any>(UserEndPoint.UserPortal.GET_FEATURE);
    }


    // Get Ocean Registered user in AIR to save
    // getOceanRegisteredUser(body: any = {}) {
    //     return this.http.post<any>(UserEndPoint.UserPortal.REGISTER_AIR, body);
    // }
    // Get all existing users

    getAllPendingUsers() {
        return this.http.get<any>(UserEndPoint.UserPortal.GET_ALL_PENDING_USERS);
    }

    getAllAirUsers(): Observable<any> {
        return this.http.get<any>(UserEndPoint.UserPortal.GET_ALL_AIR_USERS);
    }

    getAllAirCompanies(): Observable<any[]> {
        return this.http.get<any[]>(UserEndPoint.UserPortal.GET_ALL_COMPANIES);
    }

    getUserDetails(body: any = {}): Observable<any> {
        return this.http.post<any>(UserEndPoint.UserPortal.GET_USER_DETAILS, body);
    }

    saveAirUser(user: AirUserDTO): Observable<any> {
        const url = UserEndPoint.UserPortal.SAVE_AIR_USER;
        return this.http.post<any>(url, user)

    }

    getUsers() {
        return this.assignments;
    }

    getFeatureList(requestPayload: any = { userId: null }) {
        return this.http.post<any>(
            settings.AdminEndPoint.UserManagement.USERS_FEATURE,
            requestPayload
        );
    }

    getCompnayList(requestPayload: any = { userId: null }) {
        return this.http.post<any>(
            settings.AdminEndPoint.UserManagement.USERS_COMPANIES,
            requestPayload
        );
    }

    setAirKeyReferenceSettings(body: any = {}) {
        let url = settings.UserEndPoint.UserPortal.SET_KEY_REFERENCE_SETTINGS;
        return this.http.post<any>(url, body)
    }

    saveUpdateCompany(requestPayload: any = {}) {
        this.clearUsersCompanyCache().subscribe();
        return this.http.post<any>(
            settings.AdminEndPoint.UserManagement.SAVE_UPDATE_COMPANIES,
            requestPayload
        );
    }

    saveUpdateFeature(requestPayload: any = {}) {
        return this.http.post<any>(
            settings.AdminEndPoint.UserManagement.SAVE_UPDATE_FEATURE,
            requestPayload
        );
    }

    clearUsersCompanyCache() {
        return this.http.get<any>(settings.AdminEndPoint.Cache.CACHE_COMPANY);
    }

    getUsersCompanyList() {
        let url = settings.AdminEndPoint.UserManagement.GET_USERS;
        return this.http.get<any>(url);
    }

    getAllCompanies(body: string = 'group') {
        let params = new HttpParams();
        params = params.append('configType', body);
        return this.http.get<any>(
            settings.AdminEndPoint.CustomerManagement.GET_CUSTOMER_CONFIG,
            { params }
        );
    }

    getAirUserConfig() {
        return new Promise((resolve: any, reject: any) => {
            this.http
                .get<any>(settings.UserEndPoint.UserPortal.USER_CONFIG)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }


    // getUserAttribute(userEmail: string): Promise<any> {
    //     // Return cached data if available
    //     if (this.userAttributeLoaded) {
    //       return Promise.resolve(this.userAttributeCache.getValue());
    //     }

    //     // Create cached observable if not exists
    //     if (!this.cachedAttribute$) {
    //       const requestPayload = { userEmail };

    //       this.cachedAttribute$ = this.http
    //         .post<any>(settings.UserEndPoint.UserPortal.IS_BDP_EMPLOYEE, requestPayload)
    //         .pipe(
    //           shareReplay(1)
    //         );

    //       // Cache the first response
    //       this.cachedAttribute$.subscribe(
    //         (response: any) => {
    //           this.userAttributeCache.next(response);
    //           this.userAttributeLoaded = true;
    //         },
    //         error => {
    //           console.error('Error fetching user attributes:', error);
    //         }
    //       );
    //     }

    //     return new Promise((resolve, reject) => {
    //       this.cachedAttribute$.subscribe(resolve, reject);
    //     });
    //   }
    updateUsers(userId: string, companies: [], userRoleId: number) {
        let reqBody = {
            companies: companies,
            userId: userId,
            userRoleId: userRoleId,
        };
        let url = settings.AdminEndPoint.UserManagement.UPDATE_USERS;
        return this.http.post<any>(url, reqBody);
    }

    updateUserFeature(features: any) {
        this.userFeaturesPromise.next(features);
    }

    updateUserCompany(companies: any) {
        this.userCompanyPromise.next(companies);
    }

    updateUserSettings(settings: any) {
        if (!settings.thresholdLimit) {
            settings.thresholdLimit = {};
        }
        let isLimitNull =
            settings.thresholdLimit.minLimit == null &&
            settings.thresholdLimit.maxLimit == null;
        if (settings.thresholdLimit && !isLimitNull) {
            this.filterService.updateETAThreshold(settings.thresholdLimit);
        } else {
            settings.thresholdLimit.minLimit = -12;
            settings.thresholdLimit.maxLimit = 12;
            this.filterService.updateETAThreshold(settings.thresholdLimit);
        }

        if (settings.keyReference) {
            this.filterService.updateAirKeyRef(
                settings.keyReference.keyReference
            );
        } else {
            this.filterService.updateAirKeyRef('1');
        }

        if (settings.features) {
            settings.features = this.commonService.getSortedArray(
                settings.features,
                'id'
            );
            this.storageService.setItem('userFeatures', settings.features);
            this.updateUserFeature(settings.features);
        } else {
            const features = [{ id: 1, name: 'Event Tracking' },
            { id: 2, name: 'Data Management' },
            { id: 3, name: 'User Management' }];
            this.storageService.setItem('userFeatures', features);
            this.updateUserFeature(features);
        }

        if (settings.companies) {
            this.updateUserCompany(settings.companies);
        } else {
            this.updateUserCompany(null);
        }
    }

    saveUpdateAirEula(requestPayload: any = {}) {
        return this.http.post<any>(
            settings.UserEndPoint.UserPortal.SET_EULA,
            requestPayload
        );
    }


    //#region  Validate Air User in Ocean that session is active or not in Ocean ------for UMP
    validateAirUserInOcean(body: any = {}) {
        // Use interval instead of timer for consistent polling
        return interval(2 * 60 * 1000).pipe(
            // Start immediately
            startWith(0),
            // Switch to HTTP call
            switchMap(() => this.http.post<any>(
                settings.OceanAppRoutes.OceanCall.OCEAN_VALIDATE_USER,
                body
            )),
            // Share the subscription
            shareReplay(1)
        );
    }
    //#endregion

    //#region  UMP GET CURRENT USER
    // getUser() {
    //     return this.http.get(settings.UMPAppRoutes.UserApi.GET_CURRENT_USER);
    // }
    //#endregion

}
